import React from "react";
import { CreatableSelect } from "chakra-react-select";
import { Controller } from "react-hook-form";

const InputCreatefill = ({ options, placeholder, control, ...props }) => {
  const chakraStyles = {
    input: (provided) => ({
      ...provided,
      h: "60px",
      borderRadius: "15px",
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: "15px",
      fontSize: "md",
      fontWeight: "semibold",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontWeight: "semibold",
      fontSize: "md",
      p: "2",
    }),
  };

  return (
    <Controller
      render={({ field: { onChange, value } }) => (
        <CreatableSelect
          placeholder={placeholder}
          selectedOptionStyle="check"
          options={options || [{ value: "", label: "" }]}
          isMulti={props.isMulti}
          chakraStyles={chakraStyles}
          {...props.register}
          onChange={onChange}
          isDisabled={props.disabled}
          value={value}
        />
      )}
      control={control}
      name={props.register.name}
    />
  );
};
export default InputCreatefill;
